module.exports = __webpack_public_path__ + "static/img/invest_with_us_foot.c5fe50f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/invest_with_us_foot.png
// module id = 1732
// module chunks = 5